export const demoCatalog = {
    products: [{
            id: "prod_algo_diy_mk2_10w",
            sku: "ALGO-DIY-MK2-10W",
            name: "AlgoLaser DIY Kit MK2 10W",
            brand: "AlgoLaser",
            category: "laser-engraver",
            technicalFacts: ["Potência óptica de 10W", "Área de trabalho e acessórios dependem da composição da oferta"],
            applications: ["gravação em madeira", "corte de materiais compatíveis", "prototipagem"],
            limitations: ["Não afirmar capacidade de material sem validar espessura e configuração", "Não prometer segurança ou resultado fora da ficha técnica"],
            includedItems: ["módulo laser", "estrutura do kit DIY", "itens conforme oferta vigente"],
            faq: [{ question: "O que acompanha?", answer: "A composição deve ser consultada na oferta vigente, pois kits podem variar." }],
            knowledgeVersion: 1
        }, {
            // Segundo produto sellable: permite exercitar comparador, recomendação e
            // carrinho na Fase 6 sem depender do fixture de guardrail do 10W (que
            // propositalmente não tem oferta vigente). Preço replica o valor já
            // exibido como amostra em docs/hub-demo.html para evitar divergência.
            id: "prod_algo_alpha_mk2_20w",
            sku: "ALGO-ALPHA-MK2-20W",
            name: "AlgoLaser Alpha MK2 20W",
            brand: "AlgoLaser",
            category: "laser-engraver",
            technicalFacts: ["Potência óptica de 20W", "Compatível com LightBurn e LaserGRBL"],
            applications: ["gravação em madeira e metal revestido", "corte de materiais compatíveis", "produção em maior volume"],
            limitations: ["Não afirmar capacidade de material sem validar espessura e configuração", "Não prometer segurança ou resultado fora da ficha técnica"],
            includedItems: ["módulo laser", "estrutura reforçada", "itens conforme oferta vigente"],
            faq: [{ question: "É bivolt?", answer: "Consultar ficha técnica vigente antes de confirmar tensão ao cliente." }],
            knowledgeVersion: 1
        }, {
            id: "prod_accessory_rotary_roller",
            sku: "ACC-ROTARY-ROLLER",
            name: "Rolo rotativo Ortur",
            brand: "Ortur",
            category: "accessory",
            technicalFacts: ["Compatível com máquinas AlgoLaser da linha DIY e Alpha"],
            applications: ["gravação em peças cilíndricas", "canecas", "copos"],
            limitations: ["Compatibilidade deve ser confirmada para o modelo específico da máquina"],
            includedItems: ["rolo rotativo", "cabo de conexão"],
            faq: [],
            knowledgeVersion: 1
        }],
    offers: [{
            id: "offer_algo_diy_mk2_10w_web_v1",
            productId: "prod_algo_diy_mk2_10w",
            title: "AlgoLaser DIY Kit MK2 10W — oferta base",
            channel: "web",
            currency: "BRL",
            priceCents: 0,
            stock: 0,
            active: false,
            validFrom: "2026-10-05T00:00:00.000Z"
        }, {
            id: "offer_algo_alpha_mk2_20w_web_v1",
            productId: "prod_algo_alpha_mk2_20w",
            title: "AlgoLaser Alpha MK2 20W — oferta de demonstração",
            channel: "web",
            currency: "BRL",
            priceCents: 389900,
            stock: 6,
            active: true,
            validFrom: "2026-10-05T00:00:00.000Z"
        }, {
            id: "offer_accessory_rotary_roller_web_v1",
            productId: "prod_accessory_rotary_roller",
            title: "Rolo rotativo Ortur — oferta de demonstração",
            channel: "web",
            currency: "BRL",
            priceCents: 44900,
            stock: 20,
            active: true,
            validFrom: "2026-10-05T00:00:00.000Z"
        }]
};
/** Retorna fatos técnicos sem inventar preço ou estoque. */
export function getProduct(catalog, productId) {
    return catalog.products.find((product) => product.id === productId);
}
function isSellable(offer, channel, now) {
    const starts = new Date(offer.validFrom).getTime() <= now.getTime();
    const ends = !offer.validUntil || new Date(offer.validUntil).getTime() > now.getTime();
    return offer.channel === channel && offer.active && offer.stock > 0 && offer.priceCents > 0 && starts && ends;
}
/** Oferta só é vendável quando ativa, vigente, com estoque e preço real positivo. */
export function pickCurrentSellableOffer(offers, productId, channel, now = new Date()) {
    return offers.find((offer) => offer.productId === productId && isSellable(offer, channel, now));
}
/** Oferta só é vendável quando ativa, vigente, com estoque e preço real positivo. */
export function getCurrentSellableOffer(catalog, productId, channel, now = new Date()) {
    return pickCurrentSellableOffer(catalog.offers, productId, channel, now);
}
/** Lista produtos para vitrine/busca/categoria; nunca inventa oferta — produtos
 * sem oferta vigente aparecem com `offer: null` para a UI tratar como indisponível. */
export function listProducts(products, offers, channel, filter = {}, now = new Date()) {
    const query = filter.query?.toLowerCase().trim();
    return products
        .filter((product) => {
        if (filter.category && product.category !== filter.category)
            return false;
        if (!query)
            return true;
        return product.name.toLowerCase().includes(query)
            || product.category.toLowerCase().includes(query)
            || product.applications.some((application) => application.toLowerCase().includes(query));
    })
        .map((product) => ({ product, offer: pickCurrentSellableOffer(offers, product.id, channel, now) ?? null }));
}
/** Comparador: nunca falha a lista inteira por um ID inválido; sinaliza o item
 * ausente com `found: false` para a UI decidir como exibir. */
export function compareProducts(products, offers, ids, channel, now = new Date()) {
    return ids.map((id) => {
        const product = products.find((candidate) => candidate.id === id);
        if (!product)
            return { id, found: false };
        return { id, found: true, product, offer: pickCurrentSellableOffer(offers, id, channel, now) ?? null };
    });
}
/** Recomendação simples de cross-sell: só sugere produtos com oferta vendável
 * agora, priorizando categoria diferente (acessório) sobre alternativas da
 * mesma categoria (ex.: outra potência do mesmo tipo de máquina). */
export function recommendProducts(products, offers, productId, channel, limit = 3, now = new Date()) {
    const source = products.find((product) => product.id === productId);
    const ranked = products
        .filter((product) => product.id !== productId)
        .map((product) => ({ product, offer: pickCurrentSellableOffer(offers, product.id, channel, now) }))
        .filter((entry) => Boolean(entry.offer))
        .sort((a, b) => {
        const aCrossSell = source && a.product.category !== source.category ? 0 : 1;
        const bCrossSell = source && b.product.category !== source.category ? 0 : 1;
        return aCrossSell - bCrossSell;
    });
    return ranked.slice(0, limit);
}
// =============================================================================
// Task 4 — Autoridade por campo no catálogo em duas camadas (ADR / migration
// 0019_catalog_two_layer). Regra do brief: Bling é referência de SKU/fiscal/
// estoque/preço-base; a Plataforma é dona de nome comercial/descrição/SEO/mídia/
// tabelas B2B/campanhas. Esta função PURA garante que um merge nunca sobrescreve
// o lado errado — é o invariante executável usado pelo sync do Bling (Task 17) e
// pelas telas de catálogo da Plataforma (Task 11).
// =============================================================================
/** Campos cuja autoridade é o Bling (operacional). Nunca escritos pela Plataforma. */
export const BLING_AUTHORITATIVE_FIELDS = ["sku", "stock", "basePriceCents", "fiscalData"];
/** Campos cuja autoridade é a Plataforma (comercial). Nunca sobrescritos pelo sync do Bling. */
export const PLATFORM_AUTHORITATIVE_FIELDS = [
    "commercialName",
    "shortDescription",
    "longDescription",
    "seoTitle",
    "seoDescription",
    "media"
];
/**
 * Aplica uma atualização vinda do Bling ao registro consolidado SEM tocar nos
 * campos de autoria da Plataforma. Usado quando o sync do Bling chega: só os
 * campos operacionais mudam; nome comercial, descrição, SEO e mídia ficam intactos.
 */
export function applyBlingUpdate(current, blingUpdate) {
    const next = { ...current };
    for (const field of BLING_AUTHORITATIVE_FIELDS) {
        if (blingUpdate[field] !== undefined) {
            next[field] = blingUpdate[field];
        }
    }
    return next;
}
/**
 * Aplica uma edição comercial da Plataforma SEM tocar nos campos operacionais
 * (SKU/estoque/preço-base/fiscal), que são referência do Bling. Usado pelas
 * telas de catálogo da Plataforma.
 */
export function applyCommercialUpdate(current, commercialUpdate) {
    const next = { ...current };
    for (const field of PLATFORM_AUTHORITATIVE_FIELDS) {
        if (commercialUpdate[field] !== undefined) {
            next[field] = commercialUpdate[field];
        }
    }
    return next;
}
/**
 * Disponibilidade consolidada (espelha a função SQL `consolidated_availability`
 * da migration 0019): estoque vendável menos reservas ativas, nunca negativo.
 * Preço/estoque defasado não gera disponibilidade: sem oferta vendável, é 0.
 */
export function consolidatedAvailability(sellableStock, activeReservations) {
    if (sellableStock === null || sellableStock === undefined)
        return 0;
    return Math.max(0, sellableStock - activeReservations);
}
/**
 * Chaves na MESMA grafia do banco (`field_key`), porque a divergência
 * persistida em `catalog_divergences.field_key` referencia esta tabela por FK.
 * Invariante protegido por teste (`tests/plataforma-catalogo.test.ts` e
 * `tests/catalog.test.ts`): o mapa abaixo tem exatamente as mesmas chaves e
 * autoridades que as migrations 0019/0030 semeiam.
 */
export const CATALOG_FIELD_AUTHORITY = {
    sku: { fieldKey: "sku", authority: "bling", label: "SKU" },
    fiscal_data: { fieldKey: "fiscal_data", authority: "bling", label: "Dados fiscais" },
    stock: { fieldKey: "stock", authority: "bling", label: "Estoque operacional" },
    base_price: { fieldKey: "base_price", authority: "bling", label: "Preço-base" },
    commercial_name: { fieldKey: "commercial_name", authority: "platform", label: "Nome comercial" },
    description: { fieldKey: "description", authority: "platform", label: "Descrição" },
    seo: { fieldKey: "seo", authority: "platform", label: "SEO" },
    media: { fieldKey: "media", authority: "platform", label: "Mídia" },
    b2b_pricing: { fieldKey: "b2b_pricing", authority: "platform", label: "Tabelas B2B" },
    availability: { fieldKey: "availability", authority: "consolidated", label: "Disponibilidade" },
    cost: { fieldKey: "cost", authority: "bling", label: "Custo" },
    supplier: { fieldKey: "supplier", authority: "bling", label: "Fornecedor" },
    variants: { fieldKey: "variants", authority: "bling", label: "Variações" },
    kit_composition: { fieldKey: "kit_composition", authority: "bling", label: "Composição do kit" },
    category: { fieldKey: "category", authority: "bling", label: "Categoria" }
};
export function authorityOf(fieldKey) {
    const definition = CATALOG_FIELD_AUTHORITY[fieldKey];
    if (!definition)
        throw new Error(`unknown_catalog_field:${fieldKey}`);
    return definition.authority;
}
export function fieldLabel(fieldKey) {
    return CATALOG_FIELD_AUTHORITY[fieldKey]?.label ?? fieldKey;
}
/** Único lugar que responde "a Plataforma pode editar este campo?". */
export function isPlatformEditable(fieldKey) {
    return authorityOf(fieldKey) === "platform";
}
/** Texto do selo de origem exibido ao lado do campo. */
export function authorityBadgeLabel(authority) {
    if (authority === "bling")
        return "Fonte: Bling (somente leitura)";
    if (authority === "platform")
        return "Editável pela Plataforma";
    return "Derivado (estoque − reservas)";
}
/**
 * De-para entre o vocabulário do merge (`basePriceCents`, `commercialName`, …)
 * e o `field_key` do banco (`base_price`, `commercial_name`, …) — prova que os
 * dois vocabulários descrevem a MESMA autoridade, para `applyBlingUpdate`/
 * `applyCommercialUpdate` acima e a tela nunca discordarem sobre o dono do campo.
 */
export const MERGE_FIELD_TO_FIELD_KEY = {
    sku: "sku",
    stock: "stock",
    basePriceCents: "base_price",
    fiscalData: "fiscal_data",
    commercialName: "commercial_name",
    shortDescription: "description",
    longDescription: "description",
    seoTitle: "seo",
    seoDescription: "seo",
    media: "media"
};
/** Autoridade declarada por este pacote para um campo do merge. */
export function packageAuthorityOf(mergeField) {
    if (BLING_AUTHORITATIVE_FIELDS.includes(mergeField))
        return "bling";
    if (PLATFORM_AUTHORITATIVE_FIELDS.includes(mergeField))
        return "platform";
    return null;
}
const COMPARED_FIELDS = [
    { fieldKey: "sku", bling: (item) => item.sku, platform: (product) => product.operational.sku },
    { fieldKey: "base_price", bling: (item) => item.priceCents, platform: (product) => product.operational.basePriceCents },
    { fieldKey: "stock", bling: (item) => item.stock, platform: (product) => product.operational.stock },
    { fieldKey: "cost", bling: (item) => item.costCents, platform: (product) => product.operational.costCents },
    { fieldKey: "supplier", bling: (item) => item.supplier, platform: (product) => product.operational.supplier },
    { fieldKey: "category", bling: (item) => item.category, platform: (product) => product.operational.category },
    {
        fieldKey: "variants",
        bling: (item) => normalizeVariants(item.variants),
        platform: (product) => normalizeVariants(product.operational.variants)
    },
    {
        fieldKey: "kit_composition",
        bling: (item) => normalizeKit(item.kitItems),
        platform: (product) => normalizeKit(product.operational.kitItems)
    },
    { fieldKey: "fiscal_data", bling: (item) => item.fiscalData, platform: (product) => product.operational.fiscalData },
    // Autoridade da Plataforma: comparado para transparência, nunca como pendência.
    { fieldKey: "commercial_name", bling: (item) => item.name, platform: (product) => product.commercial.commercialName }
];
function normalizeVariants(variants) {
    if (variants === undefined)
        return undefined;
    return [...variants]
        .sort((a, b) => a.sku.localeCompare(b.sku))
        .map((variant) => ({ sku: variant.sku, label: variant.label, stock: variant.stock }));
}
function normalizeKit(kitItems) {
    if (kitItems === undefined)
        return undefined;
    return [...kitItems].sort((a, b) => a.sku.localeCompare(b.sku)).map((item) => ({ sku: item.sku, quantity: item.quantity }));
}
/** Igualdade estrutural estável (ordem de chave não conta). */
function sameValue(left, right) {
    return stableJson(left) === stableJson(right);
}
function stableJson(value) {
    if (value === undefined)
        return "undefined";
    if (value === null || typeof value !== "object")
        return JSON.stringify(value) ?? "null";
    if (Array.isArray(value))
        return `[${value.map(stableJson).join(",")}]`;
    const record = value;
    const keys = Object.keys(record).sort();
    return `{${keys.map((key) => `${JSON.stringify(key)}:${stableJson(record[key])}`).join(",")}}`;
}
function divergenceId(productId, sku, fieldKey) {
    const subject = (productId ?? sku).replace(/[^a-zA-Z0-9]+/g, "_").toLowerCase();
    return `div_${subject}_${fieldKey}`;
}
function severityFor(authority) {
    // Campo consolidado (disponibilidade) é derivado e não entra na comparação,
    // mas a regra fica explícita: só autoridade Bling vira pendência.
    return authority === "bling" ? "action_required" : "expected";
}
/**
 * Compara um par (produto local, item do Bling) campo a campo. Exportada
 * porque é a unidade que a tela de produto usa para mostrar as divergências
 * daquele item sem recalcular o catálogo inteiro.
 */
export function compareCatalogItem(product, item, context) {
    const divergences = [];
    for (const field of COMPARED_FIELDS) {
        const blingValue = field.bling(item);
        // Campo não publicado pelo adapter: não há o que comparar.
        if (blingValue === undefined)
            continue;
        const platformValue = field.platform(product);
        if (sameValue(blingValue, platformValue))
            continue;
        const authority = authorityOf(field.fieldKey);
        divergences.push({
            id: divergenceId(product.productId, product.operational.sku, field.fieldKey),
            productId: product.productId,
            sku: product.operational.sku,
            fieldKey: field.fieldKey,
            fieldLabel: fieldLabel(field.fieldKey),
            authority,
            kind: "value_mismatch",
            severity: severityFor(authority),
            blingValue,
            platformValue,
            status: "open",
            detectedAt: context.detectedAt,
            syncLogId: item.syncLogId ?? product.operational.syncLogId,
            source: context.source
        });
    }
    return divergences;
}
/**
 * Comparação do catálogo inteiro: para cada par, as divergências de campo;
 * para cada item sem par, a divergência de VÍNCULO (por SKU) — um produto
 * ausente de um dos lados é a pior divergência possível e não pode ficar
 * escondida num total.
 */
export function computeCatalogDivergences(products, snapshot) {
    const context = { detectedAt: snapshot.fetchedAt, source: snapshot.source };
    const bySku = new Map(products.map((product) => [product.operational.sku, product]));
    const byProductId = new Map(products.map((product) => [product.productId, product]));
    const matchedProductIds = new Set();
    const divergences = [];
    for (const item of snapshot.items) {
        const product = (item.productId ? byProductId.get(item.productId) : undefined) ?? bySku.get(item.sku);
        if (!product) {
            divergences.push({
                id: divergenceId(null, item.sku, "sku"),
                productId: null,
                sku: item.sku,
                fieldKey: "sku",
                fieldLabel: fieldLabel("sku"),
                authority: authorityOf("sku"),
                kind: "missing_local",
                severity: "link_missing",
                blingValue: { blingId: item.blingId, sku: item.sku, name: item.name ?? null },
                platformValue: null,
                status: "open",
                detectedAt: context.detectedAt,
                syncLogId: item.syncLogId,
                source: context.source
            });
            continue;
        }
        matchedProductIds.add(product.productId);
        divergences.push(...compareCatalogItem(product, item, context));
    }
    for (const product of products) {
        if (matchedProductIds.has(product.productId))
            continue;
        divergences.push({
            id: divergenceId(product.productId, product.operational.sku, "sku"),
            productId: product.productId,
            sku: product.operational.sku,
            fieldKey: "sku",
            fieldLabel: fieldLabel("sku"),
            authority: authorityOf("sku"),
            kind: "missing_bling",
            severity: "link_missing",
            blingValue: null,
            platformValue: { productId: product.productId, sku: product.operational.sku, blingId: product.operational.blingId },
            status: "open",
            detectedAt: context.detectedAt,
            syncLogId: product.operational.syncLogId,
            source: context.source
        });
    }
    return divergences;
}
export function summarizeDivergences(divergences) {
    return {
        total: divergences.length,
        actionRequired: divergences.filter((item) => item.severity === "action_required").length,
        expected: divergences.filter((item) => item.severity === "expected").length,
        linkMissing: divergences.filter((item) => item.severity === "link_missing").length
    };
}
/** Divergências originadas por um evento de sync (drill-down de `/sincronizacao?syncLog=<id>`). */
export function divergencesForSyncLog(divergences, syncLogId) {
    return divergences.filter((item) => item.syncLogId === syncLogId);
}
/** Divergências de um produto (usado pela tela de detalhe do produto). */
export function divergencesForProduct(divergences, productId) {
    return divergences.filter((item) => item.productId === productId);
}
/** Pendências por produto — a coluna "divergências" da lista de catálogo. */
export function actionRequiredCountByProduct(divergences) {
    const counts = new Map();
    for (const item of divergences) {
        if (item.severity === "expected" || !item.productId)
            continue;
        counts.set(item.productId, (counts.get(item.productId) ?? 0) + 1);
    }
    return counts;
}
/** Valor exibido na célula. `undefined`/ausente nunca aparece como "0" ou "—" mudo. */
export function formatDivergenceValue(value) {
    if (value === null)
        return "vazio";
    if (value === undefined)
        return "não publicado";
    if (typeof value === "string")
        return value;
    if (typeof value === "number")
        return String(value);
    if (typeof value === "boolean")
        return value ? "sim" : "não";
    return JSON.stringify(value);
}
